export type DeleteFeed = (id: string) => Promise<Record<string, never>>
